import { Link } from '..';
import { ReactRenderer } from '@tiptap/react';
import { LinkEditorBubble } from './LinkEditorBubble';
import type { LinkEditorState } from './LinkEditorBubble';

declare module '@tiptap/core' {
   interface Commands<ReturnType> {
      editableLink: {
         showLinkEditor: (state: LinkEditorState) => ReturnType;
         hideLinkEditor: () => ReturnType;
         editLink: () => ReturnType;
      };
   }
}

export const EditableLink = Link.extend({
   inclusive: false,

   onCreate() {
      let props = { editor: this.editor };
      this.storage.renderer = new ReactRenderer(LinkEditorBubble, {
         props,
         editor: this.editor,
      });
   },
   addCommands() {
      return {
         ...this.parent?.(),
         showLinkEditor:
            (state?: LinkEditorState) =>
            ({ dispatch }) => {
               if (dispatch) {
                  this.storage.renderer.ref.show(state);
               }
               return true;
            },
         hideLinkEditor:
            () =>
            ({ dispatch }) => {
               if (dispatch) {
                  this.storage.renderer.ref.hide();
               }
               return true;
            },
         editLink:
            () =>
            ({ dispatch, commands }) => {
               if (!dispatch) {
                  return true;
               }
               commands.extendMarkRange('link');
               commands.showLinkEditor('edit');
               return true;
            },
      };
   },
   addStorage() {
      return {
         renderer: null,
      };
   },
   addKeyboardShortcuts() {
      return {
         'Mod-k': () => this.editor.commands.editLink(),
      };
   },
   onSelectionUpdate() {
      if (this.editor.isActive('link')) {
         this.editor.commands.showLinkEditor(null);
      } else {
         this.editor.commands.hideLinkEditor();
      }
   },
   onExit() {
      this.storage.renderer.destroy();
   },
   addPasteRules() {
      return [];
   },
}).configure({ openOnClick: false, linkOnPaste: false, autolink: false });
